var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-dialog',{staticClass:"p-fluid",attrs:{"visible":_vm.visible,"containerStyle":"","header":_vm.header,"modal":true,"baseZIndex":_vm.baseZIndex,"contentStyle":Object.assign({}, _vm.contentStyle,
    {'overflow-y': 'auto',
    width: '800px',
    'max-width': 'min(800px, 100%)',
    'max-height': '70vh'}),"closeOnEscape":_vm.closeOnEscape,"closable":_vm.closable},on:{"hide":function($event){return _vm.$emit('close')},"update:visible":function($event){return _vm.$emit('close')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }